<template>
  <div class="grid-map-menu-body">
    <component
      :is="scrollbarTag"
      class="grid-map-scroll-area--customizer pt-4 pb-6"
      :settings="settings"
      :key="$vs.rtl"
    >
      <ul class="mt-1">
        <li
          class="aisea-pb-6 aisea-pl-4 aisea-pr-4"
          v-for="plot in plots"
          :key="plot.id"
        >
          <plot-card
            :plot="plot"
            :jumpToPlot="jumpToPlot"
            :isSelected="trackingTarget === plot.id"
          />
        </li>
      </ul>
    </component>
  </div>
</template>

<script>
/**
 * マップ右メニューのプロット一覧を表示するコンポーネント
 * @parent O.RightMenuBase
 */
import * as turf from "@turf/turf";
import { mapGetters } from "vuex";
import { createNamespacedHelpers } from "vuex";
import { ColorMixin } from "@/mixins";
import FireStoreService from "@/services/fireStoreService";
import PlotCard from "@/components/molecules/PlotCard";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

const { mapActions: mapActionsOfLiveMap } = createNamespacedHelpers("liveMap");

const {
  mapMutations: mapMutationsOfGridMap,
  mapState: mapStateOfGridMap,
  mapGetters: mapGettersOfGridMap,
} = createNamespacedHelpers("gridMap");

export default {
  name: "O.Plot",
  mixins: [ColorMixin],
  components: {
    PlotCard,
    VuePerfectScrollbar,
  },
  props: {
    /** スクロールの設定 */
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    ...mapStateOfGridMap({
      activeSidebarForGrid: (state) => state.activeSidebarForGrid,
    }),
    ...mapGetters({
      plots: "enterprisePlot/getPlots",
    }),
    ...mapGettersOfGridMap(["getTrackingTarget"]),
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    // FireStoreで追跡設定しているターゲットがplotならIDを返す
    trackingTarget() {
      return this.getTrackingTarget({
        mapId: this.activeSidebarForGrid.mapId,
        type: "plot",
      });
    },
  },
  mounted() {
    this.searchPlots(0);
  },
  methods: {
    ...mapActionsOfLiveMap(["showVesselDetail"]),
    ...mapMutationsOfGridMap([
      "UPDATE_GRID_MAP_SETTINGS",
      "UPDATE_LAST_TRACKING_POSITION",
    ]),
    searchPlots(page) {
      let request = {
        start: page,
        limit: 99999,
      };
      this.$store.dispatch("enterprisePlot/fetchPlots", request);
    },
    // 選択したプロットの座標にズームされる
    async jumpToPlot(plot) {
      const mapId = this.activeSidebarForGrid.mapId;
      if (!mapId) return;
      // 選択中のカードをクリックしたら選択を解除しデフォルトポジションに戻る
      if (this.trackingTarget === plot.id) {
        this.UPDATE_LAST_TRACKING_POSITION({
          mapId: mapId,
          center: [],
        });
        return;
      }
      if (plot.plot_points) {
        const collections = plot.plot_points.map((e) => {
          return turf.point([e.longitude, e.latitude]);
        });
        const features = turf.featureCollection(collections);
        const center = turf.center(features);
        // store(vuex)更新
        this.UPDATE_LAST_TRACKING_POSITION({
          mapId: mapId,
          center: center.geometry.coordinates,
        });
        this.UPDATE_GRID_MAP_SETTINGS({
          map_id: mapId,
          tracking_target: { type: "plot", id: plot.id },
        });
        // FireStore更新
        await FireStoreService.setGridMapSettings(mapId, {
          tracking_target: { type: "plot", id: plot.id },
        });
      } else {
        this.$vs.notify({
          title: "位置情報がありません",
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
</style>
